import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="output-patterns--form"
export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.updateSummary();
  }

  updateSummary() {
    const availableCount = this.formTarget.querySelectorAll("#availableTbody tr").length;
    const detailCount    = this.formTarget.querySelectorAll("#detailTbody tr").length;
    const updatedAt      = this.formTarget.querySelector("input[name='updated_at']").value;

    document.getElementById("updatedAt").textContent      = updatedAt;
    document.getElementById("availableCount").textContent = availableCount;
    document.getElementById("detailCount").textContent    = detailCount;
  }

  extractOutputItemData(row) {
    const tds = row.querySelectorAll("td");

    // checkbox + id
    const checkbox = tds[0].querySelector("input");
    const id = checkbox.dataset.id || checkbox.value;

    const name = tds[3].cloneNode(true);
    name.querySelector(".pattern-badge")?.remove();
    const cleanText = name.textContent.trim();

    return {
      classes: row.classList,
      id: id,
      category: tds[2].textContent.trim(),
      name: cleanText,
    };
  }

  buildOutputPatternDetail(data, newIndex) {
    const { id, classes, category, name } = data;

    const newRow = document.createElement("tr");
    newRow.classList.add(classes);

    newRow.innerHTML = `
      <td>
        <input type="checkbox" value="${id}" data-id="${id}">
      </td>
      <td>${newIndex}</td>
      <td>${id}</td>
      <td>${category}</td>
      <td>
        <input type="text" value="${name}" class="inline-input">
      </td>
      <td>
        <div class="row-actions">
          <button type="button" class="btn mini-btn" data-action="click->output-patterns--form#moveDetailUp" data-id="${id}">↑</button>
          <button type="button" class="btn mini-btn" data-action="click->output-patterns--form#moveDetailDown" data-id="${id}">↓</button>
        </div>
      </td>
    `;

    return newRow;
  }

  resetCheckedOutputItemsCheckbox() {
    this.formTarget
        .querySelectorAll(`#availableTbody td:nth-of-type(1) > input[type="checkbox"]:checked`)
        .forEach(cb => cb.checked = false);
  }

  getDetailsItemIds() {
    const ids = [];
    this.formTarget
        .querySelectorAll(`#detailTbody td:nth-of-type(1) input[type="checkbox"]`)
        .forEach(cb => {
      const id = cb.dataset.id || cb.value;
      ids.push(id);
    });
    return ids;
  }

  addPatternBadges(ids) {
    const rows = ids
      .map(id => document.querySelector(`tr:has(input[data-id="${id}"])`))
      .filter(Boolean);

    rows.forEach(row => {
      const targetCell = row.querySelectorAll("td")[3];

      if (!targetCell) return;

      if (!targetCell.querySelector(".pattern-badge")) {
        const badge = document.createElement("span");
        badge.className = "pattern-badge";
        badge.textContent = "登録済";

        targetCell.appendChild(badge);
      }
    });
  }

  removeAllPatternBadges() {
    this.formTarget
        .querySelectorAll("#availableTbody .pattern-badge")
        .forEach(e => e.remove());
  }

  resetPatternBadges() {
    const ids = this.getDetailsItemIds();
    this.removeAllPatternBadges();
    this.addPatternBadges(ids);
  }

  resetDetailsIndexNumber() {
    this.formTarget
      .querySelectorAll("#detailTbody tr")
      .forEach((row, index) => {
        const indexCell = row.querySelector("td:nth-of-type(2)");
        
        if (indexCell) {
          indexCell.textContent = index + 1;
        }
      });
  }

  addDetails() {
    const detailTbody = this.formTarget.querySelector("#detailTbody");
    const ids = [];
    
    this.formTarget
        .querySelectorAll(`#availableTbody td:nth-of-type(1) > input[type="checkbox"]:checked`)
        .forEach(e => {
      const data      = this.extractOutputItemData(e.closest("tr"));
      const hasDetail = detailTbody.querySelector(`td:nth-of-type(1) > input[type="checkbox"][data-id="${data.id}"]`);

      if (!hasDetail) {
        const lastCell = detailTbody.querySelector("tr:last-of-type td:nth-of-type(2)");
        const newIndex = lastCell ? parseInt(lastCell.innerText, 10) + 1 : 1;
        
        detailTbody.appendChild(this.buildOutputPatternDetail(data, newIndex));

        ids.push(data.id);
      }
    });
    
    this.resetCheckedOutputItemsCheckbox();
    this.resetPatternBadges();
    this.updateSummary();
  }

  removeDetails() {
    this.formTarget
        .querySelectorAll(`#detailTbody td:nth-of-type(1) > input[type="checkbox"]:checked`)
        .forEach(cb => cb.closest("tr").remove());
    this.resetPatternBadges();
    this.updateSummary();
  }

  addAllToDetails() {
    this.formTarget
        .querySelectorAll(`#availableTbody td:nth-of-type(1) > input[type="checkbox"]`)
        .forEach(el => el.checked = true);
    this.addDetails();
  }

  removeAllDetails() {
    this.formTarget
        .querySelectorAll(`#detailTbody td:nth-of-type(1) > input[type="checkbox"]`)
        .forEach(el => el.checked = true);
    this.removeDetails();
  }

  moveDetailUp(event) {
    const row = event.currentTarget.closest("tr");
    const prevRow = row.previousElementSibling;

    if (prevRow) {
      row.parentNode.insertBefore(row, prevRow);
    }
    this.resetDetailsIndexNumber();
  }

  moveDetailDown(event) {
    const row = event.currentTarget.closest("tr");
    const nextRow = row.nextElementSibling;

    if (nextRow) {
      row.parentNode.insertBefore(nextRow, row);
    }
    this.resetDetailsIndexNumber();
  }
}
